/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServizioMensaMenuType } from './servizio-mensa-menu-type';


export interface ServizioMensaMenuDTO { 
    id?: string;
    tipo?: ServizioMensaMenuType;
    identificativo?: string;
    urlFile?: string;
}



